import { findResource, findSubresource, hasAuthorizedPermission } from "helpers/permissionsHelper";
import { useSelector } from "react-redux";

export const usePermissions = () => {
	const permissions = useSelector((state) => state.auth?.user?.permissions);

	const hasPermission = (resourceName, permission, subresourceName, subpermission) => {
		const resource = findResource(permissions, resourceName);
		if (!resource) return false;

		if (subresourceName) {
			const subResource = findSubresource(resource, subresourceName);
			if (!subResource) return false;

			return subpermission ? hasAuthorizedPermission(subResource.permissions, subpermission) : true;
		}

		return hasAuthorizedPermission(resource.permissions, permission);
	};

	const getSubresource = (resourceName, subresourceName) => {
		const resource = findResource(permissions, resourceName);
		return findSubresource(resource, subresourceName);
	};

	return { hasPermission, getSubresource };
};
